import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Link } from '@aftersale-next/ui';
import { useTroquefacilRedirectLink } from '../../hooks/use-troquefacil-redirect-link';
export default function ActionReturnOrExchange() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var troqueFacilRedirectLink = useTroquefacilRedirectLink();

  if (!troqueFacilRedirectLink) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsx(Link, {
    "data-testid": "return-or-exchange-button",
    target: "_blank",
    href: troqueFacilRedirectLink,
    size: "14px",
    lineHeight: "16px",
    children: t('ACTION_RETURN_OR_EXCHANGE')
  });
}